
export enum PAGE_STEPER_STAGES {
   FORM = 'FORM',
   BANK_VERIFICATION = 'BANK_VERIFICATION',
   CONTRACT_SIGNING =  'CONTRACT_SIGNING',
   SUBMIT_APPLICATION = 'SUBMIT_APPLICATION', 
} 

export enum PAGE_STEPPER_MODES {
   DEFAULT = 'DEFAULT', 
   MOBYWATEL = 'MOBYWATEL',
   RETENTION = 'RETENTION'
}

export interface ISignlePageStep {
   name: keyof typeof PAGE_STEPER_STAGES;
   label: string;
   index: number;
}

export interface DefaultModeSteps {
   [PAGE_STEPER_STAGES.FORM]: ISignlePageStep;
   [PAGE_STEPER_STAGES.BANK_VERIFICATION]: ISignlePageStep;
   [PAGE_STEPER_STAGES.CONTRACT_SIGNING]: ISignlePageStep;
}

export interface RetentionModeSteps {
   [PAGE_STEPER_STAGES.SUBMIT_APPLICATION]: ISignlePageStep;
   [PAGE_STEPER_STAGES.CONTRACT_SIGNING]: ISignlePageStep;
}

export interface MObywatelModeSteps {
   [PAGE_STEPER_STAGES.FORM]: ISignlePageStep;
   [PAGE_STEPER_STAGES.SUBMIT_APPLICATION]: ISignlePageStep;
   [PAGE_STEPER_STAGES.CONTRACT_SIGNING]: ISignlePageStep;
}


export type TSinglePageStepMode = {
   [key in PAGE_STEPER_STAGES]?: ISignlePageStep
}

// Define the overall structure
export type TAllPageStepsModes = {
   [key in PAGE_STEPPER_MODES]: TSinglePageStepMode;
}


export const allPageStepsModes: TAllPageStepsModes = {
   // DOMYŚLNY
   [PAGE_STEPPER_MODES.DEFAULT]: {
      [PAGE_STEPER_STAGES.FORM]: {
         name: PAGE_STEPER_STAGES.FORM,
         index: 1,
         label: 'Podaj dane',
      },
      [PAGE_STEPER_STAGES.BANK_VERIFICATION]: {
         name: PAGE_STEPER_STAGES.BANK_VERIFICATION,
         index: 2,
         label: 'Potwierdź',
      },
      [PAGE_STEPER_STAGES.CONTRACT_SIGNING]: {
         name: PAGE_STEPER_STAGES.CONTRACT_SIGNING,
         index: 3,
         label: 'Opłać',
      },
   },

   // RETENCJA
   [PAGE_STEPPER_MODES.RETENTION]: {
      [PAGE_STEPER_STAGES.SUBMIT_APPLICATION]: {
         name: PAGE_STEPER_STAGES.SUBMIT_APPLICATION,
         index: 1,
         label: 'Złóż wniosek',
      },
      [PAGE_STEPER_STAGES.CONTRACT_SIGNING]: {
         name: PAGE_STEPER_STAGES.CONTRACT_SIGNING,
         index: 2,
         label: 'Opłać',
      },
   },

   // MOBYWATEL
   [PAGE_STEPPER_MODES.MOBYWATEL]: {
      [PAGE_STEPER_STAGES.FORM]: {
         name: PAGE_STEPER_STAGES.FORM,
         index: 1,
         label: 'Podaj dane',
      },
      [PAGE_STEPER_STAGES.SUBMIT_APPLICATION]: {
         name: PAGE_STEPER_STAGES.SUBMIT_APPLICATION,
         index: 2,
         label: 'Złóż wniosek',
      },
      [PAGE_STEPER_STAGES.CONTRACT_SIGNING]: {
         name: PAGE_STEPER_STAGES.CONTRACT_SIGNING,
         index: 3,
         label: 'Opłać',
      },
   }
}